import { Component, h, Element } from '@stencil/core';
/**
 * COMPNAME is for creating a container for displaying price, product features, and a CTA for a product
 */
@Component({
  tag: 'aafp-sales-card',
  shadow: false,
})
export class AafpSalesCard {
  @Element() element: HTMLElement;

  render() {
    return (
      <div class="adl-sales-card">
        <div class="adl-sales-card__heading">
          <slot name="heading" />
        </div>
        <div class="adl-sales-card__pricing">
          <slot name="price-lead-text" />
          <div class="adl-sales-card__price">
            <slot name="price" />
          </div>
        </div>
        <div class="adl-sales-card__content">
          <div class="adl-sales-card__features">
            <slot name="features" />
          </div>
          <div class="adl-sales-card__cta">
            <slot name="cta" />
          </div>
        </div>
      </div>
    );
  }
}
